export const QUARTERLY = 'quarterly';
export const MONTHLY = 'monthly';

export const GROUP_ROLE = 'group';
export const INDIVIDUAL_ROLE = 'individual';
export const INDIVIDUAL_POLICY_ROLE = 'individual_policy';
export const TEAM_POLICY_ROLE = 'team_policy_role';
export const GROUP_SUMMARY = 'group_summary';
export const INDIVIDUAL_SUMMARY = 'individual_summary';
export const SUMMARY = 'summary';
export const EMPTY_SUMMARY = 'empty_summary';
export const MAX_HIER_LVL = 11;
export const AGT_PROFILE_CODE = 'AGT';
export const LEADER_PROFILE_CODE = 'LEADER';

export const POLICY_BTN_STYLED = {
  padding: '0.5rem',
  width: '9rem',
  '@media (max-width: 475px)': {
    marginLeft: '0',
    marginRight: '1rem',
    marginTop: '1rem',
  },
};

export const POLICY_HEADER_STYLED = {
  height: '22.5rem',
  '@media (max-width: 475px)': {
    overflow: 'overlay',
  },
};

export const DUE_INSURANCE_FEE_PERCENTAGE_TITLE =
  '(Phí BH đã thu / Tổng phí BH phải thu) * 100';

export const DUE_INSURANCE_FEE_PERCENTAGE_TITLE_AD_ACB =
  'Tổng phí Bảo Hiểm (BH) thực thu năm 2 của những HĐBH có ngày hiệu lực hợp đồng trong tháng T - 14 / Tổng phí BH phải thu năm 2 của những HĐBH có ngày hiệu lực hợp đồng trong tháng T - 14';

export const DUE_INSURANCE_FEE_PERCENTAGE_TITLE_IND_ACB =
  '[1 - (Phí AFYP SPC của HĐ mất hiệu lực hoặc huỷ trong tháng T-14/Tổng AFYP SPC của HĐ hiệu lực trong tháng T-14)] * 100';

export const dateTypeConfig = {
  primaryId: 'dateTypeId',
  primaryName: 'dateTypeName',
};

export const datetimeConfig = {
  primaryId: 'datetimeId',
  primaryName: 'datetimeName',
};
export const defaultProfile = {
  order: 1,
  id: 'ACT1',
  code: '',
  name: 'My Name',
  shortName: 'My Name',
  role: 'group',
};
export const tabs = [
  {
    id: GROUP_ROLE,
    name: 'Nhóm',
  },
  {
    id: INDIVIDUAL_ROLE,
    name: 'Cá nhân',
  },
  {
    id: TEAM_POLICY_ROLE,
    name: 'Danh sách HĐ theo nhóm',
  },
];
export const flairTabs = [
  {
    id: GROUP_ROLE,
    name: 'Nhóm',
  },
  {
    id: TEAM_POLICY_ROLE,
    name: 'Danh sách HĐ theo nhóm',
  },
];
export const dateTypeItem = [
  {
    dateTypeId: QUARTERLY,
    dateTypeName: 'Quý',
  },
  {
    dateTypeId: MONTHLY,
    dateTypeName: 'Tháng',
  },
];

export const defaultDoughnutChart = {
  labels: ['Anonymous', 'Other'],
  datasets: [
    {
      data: [10, 20],
      backgroundColor: ['#65A8A8FF', '#E1E1DFFF'],
      hoverBackgroundColor: ['#FEBE10FF', '#FEBE10FF'],
      hoverBorderColor: ['#E0DCD1', '#E0DCD1'],
    },
  ],
};

export const sortByFieldMap = {
  renewalPremiumRate: 'renw_prem_pct',
};

export const policySortByFieldMap = {
  issuedDate: 'issued_dt',
  customerName: 'cli_nm',
  servicingAgentName: 'serv_agt_nm',
  servicingAgentBranch: 'serv_agt_br',
  policyBranch: 'orig_team_cd',
  totalProductCollectedAmount: 'total_prod_colct_amt',
  totalProductCollectableAmount: 'total_prod_due_amt',
  t14TotalProductCollectedAmount: 't14_total_prod_colct_amt',
  t25T15TotalProductCollectedAmount: 't25_t15_total_prod_colct_amt',
  totalProductLapsedAmount: 'ape_laps_amt',
  totalProductCollectedSecondYearAmount: 'y2_total_prod_colct_amt',
};

export const PolicyBillModeMap = {
  12: 'Năm',
  6: 'Nửa Năm',
  3: 'Quý',
  1: 'Tháng',
};

export const PolicySttMap = {
  U: 'Yêu cầu GQQLBH quyền lợi tử vong',
  V: 'Yêu cầu GQQLBH quyền lợi bệnh hiểm nghèo',
  1: 'Đang có hiệu lực',
  2: 'Miễn đóng phí trong trường hợp người đóng phí tử vong',
  3: 'HĐ đã hoàn tất đóng phí',
  4: 'HĐ đã hoàn tất đóng phí',
  A: 'Hủy trong 21 ngày cân nhắc',
  B: 'Mất hiệu lực',
  C: 'Sắp phát hành',
  D: 'Tử vong',
  E: 'Chấm dứt hợp đồng',
  F: 'Hoàn tất chi trả',
  H: 'Đáo hạn',
  M: 'Chuyển phí cho HĐ khác',
  PCCC: 'Đang xử lý',
  PCCU: 'Đang xử lý',
  PCRC: 'Đang xử lý',
  PCRU: 'Đang xử lý',
  PECC: 'Đang xử lý',
  PECU: 'Đang xử lý',
  PERC: 'Đang xử lý',
  PERU: 'Đang xử lý',
  R: 'Từ chối',
  T: 'Chuyển qua hồ sơ khác',
  W: 'N/A',
  X: 'N/A',
  K: 'Chuyển tài khoản',
  S: 'Tạm dừng đóng phí',
  6: 'Quyền lợi Thương tật toàn bộ và vĩnh viễn đã được chi trả. Hợp đồng vẫn được giữ lại để khách hàng được nhận các quyền lợi học vấn',
  G: 'Quyền lợi Thương tật toàn bộ và vĩnh viễn đã được chi trả. Hợp động kết thúc (chấm dứt hiệu lực)',
  5: 'Quyền lợi Tử vong đã được chi trả. Hợp đồng vẫn được giữ lại để khách hàng được nhận các quyền lợi học vấn',
  R1: 'Đang xử lý',
  R2: 'Đang xử lý',
  R3: 'Đang xử lý',
};

export const polSttCodeConfig = {
  primaryId: 'polSttCodeId',
  primaryName: 'polSttCodeName',
};

export const polSttCodeItems = [
  {
    polSttCodeId: '1',
    polSttCodeName: PolicySttMap['1'],
  },
  {
    polSttCodeId: 'B',
    polSttCodeName: PolicySttMap.B,
  },
  {
    polSttCodeId: 'E',
    polSttCodeName: PolicySttMap.E,
  },
];

export const PoliciesFilterFormConstructor = {
  policyNumber: {
    label: 'Số hợp đồng',
    type: 'number',
    name: 'policyNumber',
  },
  policyStatusCode: {
    label: 'Trạng thái hợp đồng',
    type: 'select-adv',
    name: 'policyStatusCode',
    config: polSttCodeConfig,
    items: polSttCodeItems,
  },
  issuedDateFrom: {
    label: 'Ngày hiệu lực HĐ',
    type: 'date',
    name: 'issuedDateFrom',
    selectOnly: true,
    defaultValue: null,
    unvalue: true,
  },
  issuedDateTo: {
    label: 'Đến ngày',
    type: 'date',
    name: 'issuedDateTo',
    selectOnly: true,
    defaultValue: null,
    unvalue: true,
  },
  serviceAgentInfo: {
    label: 'Mã tư vấn - Tên tư vấn',
    type: 'text',
    name: 'serviceAgentInfo',
  },
};
